import loggedReduscer from './loggedReducer'
import userInfo from './userInfo'
import merged from './merged'
import registeruserInfo from './registerUserInfo'
import buyPolicyReducer from './buyPolicyReducer'
import buyPolicyMotorReducer from './buyPolicyMotorReducer'
import addressReducer from './addressReducer'
import tourReducer from 'src/reducers/TourReducer'
import paCoverAmountReducer from 'src/reducers/paCoverAmountReducer'
import { combineReducers } from 'redux'
import searchPersistenceReducer from 'src/reducers/searchPersistenceReducer'
import notificationReducer from 'src/reducers/notificationReducer'
import insuranceProvider from 'src/reducers/insuranceProviderList'
import buyPolicyLifeReducer from 'src/reducers/buyPolicyLifeReducer'
import expiredFilterParamsReducer from './expiredFilterparamReducer'
import buyPolicyTitleReducer from 'src/reducers/buyPolicyTitleReducer'

const allReducers = combineReducers({
  loggedReduscer,
  userInfo,
  merged,
  registeruserInfo,
  buyPolicyReducer,
  addressReducer,
  buyPolicyMotorReducer,
  tourReducer,
  paCoverAmountReducer,
  searchPersistenceReducer,
  notificationReducer,
  insuranceProvider,
  buyPolicyLifeReducer,
  expiredFilterParams: expiredFilterParamsReducer,
  buyPolicyTitle: buyPolicyTitleReducer,
})

export default allReducers
